"use client";

import { AppDownloadModal } from "@faire/deprecated-retailer-visitor-shared/components/MobileAppPromoBanner/AppDownloadModal";
import { LoggedOutAppDownloadModal } from "@faire/deprecated-retailer-visitor-shared/components/MobileAppPromoBanner/LoggedOutAppDownloadModal";
import {
  getAppsFlyerOrStoreLinks,
  getStoreLinkUrl,
} from "@faire/deprecated-retailer-visitor-shared/components/MobileAppPromoBanner/utils";
import { AppStoreBadge } from "@faire/deprecated-retailer-visitor-shared/icons/AppDownloadBadge/AppStoreBadge";
import { GooglePlayBadge } from "@faire/deprecated-retailer-visitor-shared/icons/AppDownloadBadge/GooglePlayBadge";
import { useIsLoggedInRetailer } from "@faire/marketplace-lib/serialized-data/isLoggedInRetailer";
import { trackRetailerMobileFooterDesktopappModalandroidDismissClick } from "@faire/web-api--source/events/retailerMobile/click/footerDesktopAppModalAndroidDismiss";
import { trackRetailerMobileFooterDesktopappModaliosDismissClick } from "@faire/web-api--source/events/retailerMobile/click/footerDesktopAppModalIosDismiss";
import { trackRetailerMobileFooterMwebDesktopappStoreBadgeClick } from "@faire/web-api--source/events/retailerMobile/click/footerMwebDesktopAppStoreBadge";
import { trackRetailerMobileFooterMwebDesktopgooglePlayBadgeClick } from "@faire/web-api--source/events/retailerMobile/click/footerMwebDesktopGooglePlayBadge";
import { getWindow } from "@faire/web/common/globals/getWindow";
import { trackEvent } from "@faire/web/common/trackEvent";
import { Button } from "@faire/web/slate-deprecated/Button";
import { Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import React, { useState } from "react";
import styled from "styled-components";

export enum AppModalType {
  APPSTORE = "APPSTORE",
  GOOGLEPLAY = "GOOGLEPLAY",
}

interface IProps {
  eventPrefix?: string;
  noModal?: boolean;
  onClick?: () => void;
  loggedOut?: boolean;
}

export const AppDownload: React.FC<IProps> = ({
  eventPrefix,
  noModal,
  onClick,
  loggedOut,
}) => {
  const [appModalType, setAppModalType] = useState<AppModalType>();
  const isLoggedInRetailer = useIsLoggedInRetailer();

  const handleAppStoreClick = () => {
    onClick?.();
    let appStoreLink;
    if (isLoggedInRetailer) {
      appStoreLink = getStoreLinkUrl().app_store_link;
      void trackEvent(`${eventPrefix}/app-store-badge-click`);
    } else {
      appStoreLink = getAppsFlyerOrStoreLinks().app_store_link;
      trackRetailerMobileFooterMwebDesktopappStoreBadgeClick();
    }
    if (noModal) {
      getWindow()?.open(appStoreLink);
    } else {
      setAppModalType(AppModalType.APPSTORE);
    }
  };

  const handleGooglePlayClick = () => {
    onClick?.();
    let playStoreLink;
    if (isLoggedInRetailer) {
      playStoreLink = getStoreLinkUrl().play_store_link;
      void trackEvent(`${eventPrefix}/google-play-badge-click`);
    } else {
      playStoreLink = getAppsFlyerOrStoreLinks().play_store_link;
      trackRetailerMobileFooterMwebDesktopgooglePlayBadgeClick();
    }
    if (noModal) {
      getWindow()?.open(playStoreLink);
    } else {
      setAppModalType(AppModalType.GOOGLEPLAY);
    }
  };

  const handleCloseLoggedOutAppModal = () => {
    if (appModalType === AppModalType.APPSTORE) {
      trackRetailerMobileFooterDesktopappModaliosDismissClick();
    } else {
      trackRetailerMobileFooterDesktopappModalandroidDismissClick();
    }
    setAppModalType(undefined);
  };

  const handleCloseAppModal = () => {
    setAppModalType(undefined);
  };

  return (
    <Row align="center">
      <StyledButton onClick={handleAppStoreClick} variant="tertiary">
        <AppStoreBadge />
      </StyledButton>
      <Spacer width="2x" />
      <StyledButton onClick={handleGooglePlayClick} variant="tertiary">
        <GooglePlayBadge />
      </StyledButton>
      {appModalType ? (
        <>
          {loggedOut ? (
            <LoggedOutAppDownloadModal
              appModalType={appModalType}
              onClose={handleCloseLoggedOutAppModal}
            />
          ) : (
            <AppDownloadModal
              eventPrefix={eventPrefix}
              appModalType={appModalType}
              onClose={handleCloseAppModal}
            />
          )}
        </>
      ) : null}
    </Row>
  );
};

const StyledButton = styled(Button)`
  position: static;
`;
